// Прокрутить к блоку и подсветить его один раз.
//
// ## Зачем
//
// На один длинный экран ведут РАЗНЫЕ переходы: со сводки подотчёта на сводку расчёта идут и
// «Долги сотрудников», и «Объекты с недобором», и «К выплате». Экран у них общий, а вопросы
// разные — и без указания, куда смотреть, человек приходил в начало страницы, где ответа на
// его вопрос нет. Заказчик 21.09.2026 прочёл это как «нажимаем на подробно, ничего не
// происходит», и по сути был прав: происходило не то, за чем он шёл.
//
// ## Почему ссылка-обработчик, а не обычная
//
// Первая редакция брала обычную ссылку и прокручивала в `useEffect`. На живом экране это не
// работало ни разу: блок появляется ТОЛЬКО когда приехали данные, а действие срабатывало
// сразу после первой отрисовки — когда блока ещё нет вовсе. Ссылка при этом была пуста, шаг
// молча пропускался и больше не повторялся.
//
// Ссылка-обработчик вызывается в тот миг, когда блок правда появился в разметке. Повтор
// исключён отметкой: при каждой перерисовке React передаёт ссылку заново, и без неё экран
// прокручивался бы к блоку после каждого нажатия где угодно на странице.
//
// ## Почему подсветка ОДНОКРАТНАЯ
//
// Постоянная рамка вокруг блока означает в этом продукте одно: с ним что-то не так. Вспышка
// же отвечает на другой вопрос — «вот сюда я тебя привёл», — и обязана погаснуть сама, иначе
// человек будет искать, что он сломал.

import { useCallback, useEffect, useRef, useState } from 'react';

import { cn } from '@/utils/cn';

/** Сколько держится вспышка. Хватает, чтобы глаз доехал, и мало, чтобы не стать рамкой. */
const ДЕРЖИМ_МС = 1500;

export function useФокус(нужен: boolean) {
  const [светится, setСветится] = useState(false);
  const сделано = useRef(false);
  const таймер = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(
    () => () => {
      if (таймер.current !== null) {
        clearTimeout(таймер.current);
      }
    },
    [],
  );

  const ссылка = useCallback(
    (узел: HTMLElement | null) => {
      if (!нужен || узел === null || сделано.current) {
        return;
      }
      сделано.current = true;
      узел.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setСветится(true);
      таймер.current = setTimeout(() => setСветится(false), ДЕРЖИМ_МС);
    },
    [нужен],
  );

  return { ссылка, className: cn(светится && 'ring-2 ring-primary-base') };
}
